var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgResearchTopicNavigator = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3182,
    cy: 7.31818,
    r: 7.31818,
    fill: "#A8F6D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8866 18.0231C19.2474 18.0231 21.9718 15.2452 21.9718 11.8185C21.9718 8.39186 19.2474 5.61399 15.8866 5.61399C12.5258 5.61399 9.80136 8.39186 9.80136 11.8185C9.80136 15.2452 12.5258 18.0231 15.8866 18.0231ZM15.8866 20.0913C20.3676 20.0913 24.0002 16.3874 24.0002 11.8185C24.0002 7.24964 20.3676 3.54581 15.8866 3.54581C11.4055 3.54581 7.77295 7.24964 7.77295 11.8185C7.77295 16.3874 11.4055 20.0913 15.8866 20.0913Z",
    fill: "#38DA8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2275 8.31853L14.5706 10.4399L12.5457 15.3185L17.2026 13.1972L19.2275 8.31853Z",
    fill: "#38DA8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51367 2.15007L6.00017 0.636719L6.48659 2.15007L8 2.63689L6.48661 3.12333L6.00016 4.63672L5.51367 3.12321V2.15007Z",
    fill: "#38DA8B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51367 3.12321L4 2.63689L5.51367 2.15007V3.12321Z",
    fill: "#38DA8B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14893 19.2851L4.00029 16.6367L4.85154 19.2851L7.5 20.137L4.85156 20.9883L4.00028 23.6367L3.14893 20.9881V19.2851Z",
    fill: "#38DA8B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14893 20.9881L0.5 20.137L3.14893 19.2851V20.9881Z",
    fill: "#38DA8B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResearchTopicNavigator);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;